import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { getOrders } from "../../redux/apiCalls"
import { format } from "timeago.js"
import { Visibility } from "@material-ui/icons"
// Components
import Table from "../Table/Table"
// Styles
import { Container, StyledButton, StyledLink } from "./Orders.styles"

const Orders = ({ userId }) => {
   const dispatch = useDispatch()
   const orders = useSelector((state) => state.order.orders)
   const userOrders = orders.filter((item) => item.userId === userId)

   useEffect(() => {
      getOrders(dispatch)
   }, [dispatch])

   const headers = [
      { name: "Num", width: 10, align: "left" },
      { name: "Date", width: 20, align: "left" },
      { name: "Qty", width: 15, align: "right" },
      { name: "Amount", width: 20, align: "right" },
      { name: "Status", width: 15, align: "center" },
      { name: "Details", width: 15, align: "center" },
   ]
   let data = []

   for (let i = userOrders.length - 1; i >= 0; i--) {
      data.push([
         userOrders[i].orderNumber,
         format(userOrders[i].createdAt),
         userOrders[i].totalQuantity,
         userOrders[i].amount + "€",
         <StyledButton
            buttonColor={
               userOrders[i].status === "sent"
                  ? "green"
                  : userOrders[i].status === "pending"
                    ? "blue"
                    : "red"
            }
         >
            {userOrders[i].status}
         </StyledButton>,
         <StyledLink to={`/order/${userOrders[i]._id}`}>
            <Visibility />
         </StyledLink>,
      ])
   }

   return (
      <Container>
         <Table headers={headers} data={data} pageSize={5} />
      </Container>
   )
}

Orders.propTypes = {
   userId: PropTypes.string,
}

export default Orders
